/* tslint:disable */
/* eslint-disable */
/**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DelegatorsInfo,
    DelegatorsInfoFromJSON,
    DelegatorsInfoFromJSONTyped,
    DelegatorsInfoToJSON,
} from './';

/**
 * 
 * @export
 * @interface DelegatorsResponse
 */
export interface DelegatorsResponse {
    /**
     * 
     * @type {Array<DelegatorsInfo>}
     * @memberof DelegatorsResponse
     */
    list: Array<DelegatorsInfo>;
    /**
     * 
     * @type {number}
     * @memberof DelegatorsResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof DelegatorsResponse
     */
    size?: number;
    /**
     * 
     * @type {number}
     * @memberof DelegatorsResponse
     */
    maxPage?: number;
    /**
     * 
     * @type {number}
     * @memberof DelegatorsResponse
     */
    totalSize?: number;
}

export function DelegatorsResponseFromJSON(json: any): DelegatorsResponse {
    return DelegatorsResponseFromJSONTyped(json, false);
}

export function DelegatorsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DelegatorsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(DelegatorsInfoFromJSON)),
        'page': !exists(json, 'page') ? undefined : json['page'],
        'size': !exists(json, 'size') ? undefined : json['size'],
        'maxPage': !exists(json, 'maxPage') ? undefined : json['maxPage'],
        'totalSize': !exists(json, 'totalSize') ? undefined : json['totalSize'],
    };
}

export function DelegatorsResponseToJSON(value?: DelegatorsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(DelegatorsInfoToJSON)),
        'page': value.page,
        'size': value.size,
        'maxPage': value.maxPage,
        'totalSize': value.totalSize,
    };
}


